import { Locale } from "next/router";

export const getFAQ = (content: { length: number }) => {
  return Array.from(content);
};

export const getFAQURL = (locale: Locale) => {
  return `https://support.whoppah.com/${locale}`;
};
